import { Component, OnInit } from '@angular/core';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { CommonService } from 'src/app/services/common.service';
import { ModuleMenu } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-template',
  templateUrl: './document-template.component.html',
  styleUrls: ['./document-template.component.scss']
})
export class DocumentTemplateComponent implements OnInit {
  DocAttachList: any = [];
  menudata: ModuleMenu;
  moduleid: number;
  SUB_MODULE: string;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    public headerService: HeadService
  ) { }

  ngOnInit() {
    //this.DocAttachList = [];
    let menudata = "";
    let module = this.headerService.getHeader().subscribe((result)=>{
      menudata=result.module;
      this.GetDocTemplateData(menudata);
    });
    //this.GetDocTemplateData();
  }

  GetDocTemplateData(menudata: string) {
    this.DocAttachList = [];   

    if(menudata!=null)
    {
      if (menudata === "IST") { this.moduleid = 2;  this.SUB_MODULE = "IST"}
      else if (menudata === "GRANTSCME"){ this.moduleid = 4; this.SUB_MODULE = "CME" }
      else if (menudata === "GRANTSSPONSORSHIP"){ this.moduleid = 4; this.SUB_MODULE = "SPONSORSHIP" }
      else if (menudata === "GRANTSCHARITABLE"){ this.moduleid = 4; this.SUB_MODULE = "CHARITABLE" }
      else if (menudata === "EAP") { this.moduleid = 5;  this.SUB_MODULE = "EAP"}
    }

    this.summaryService.GetMasterScreenData('api/ISTDocumentAttachment/GetScreenTemplates?ModuleID=' + this.moduleid + "&SUB_MODULE=" + this.SUB_MODULE).subscribe(summary => {
      this.DocAttachList = summary;
    });
  }
  downloadFile(fileID) {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }
  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");
  }
}
